
import { Terrace, DetailedOpeningHours } from '@/types/terrace';
import { DatabaseTerrace } from '@/types/api';

export const transformDatabaseTerrace = (data: DatabaseTerrace): Terrace => {
  // Parse detailed_opening_hours from Json to DetailedOpeningHours
  let detailedOpeningHours: DetailedOpeningHours | undefined;
  if (data.detailed_opening_hours) {
    try {
      detailedOpeningHours = typeof data.detailed_opening_hours === 'string' 
        ? JSON.parse(data.detailed_opening_hours)
        : data.detailed_opening_hours as unknown as DetailedOpeningHours;
    } catch (e) {
      console.warn("Failed to parse detailed opening hours:", e);
    }
  }

  const transformedTerrace: Terrace = {
    id: data.id,
    name: data.name,
    address: data.address,
    lat: data.lat,
    lng: data.lng,
    sunStatus: data.sun_status as 'sunny' | 'soon' | 'not-sunny',
    openingHours: data.opening_hours || '',
    detailed_opening_hours: detailedOpeningHours,
    orientation: data.orientation || '',
    hasFood: data.has_food,
    petFriendly: data.pet_friendly,
    servesAlcohol: data.serves_alcohol,
    terraceDescription: data.terrace_description,
    website: data.website,
    phone: data.phone,
    type: data.type,
    submitted_by: data.submitted_by,
    slug: data.slug,
    sun_status_last_updated: data.sun_status_last_updated,
    original_maps_url: data.original_maps_url,
    photo_url: data.photo_url || data.image_url
  };
  
  return transformedTerrace;
};
